import React from 'react';

import { VideocamIcon, InventoryIcon } from '@gogame/components';

import {
  UPLOAD_FILE_IMAGE,
  UPLOAD_FILE_VIDEO,
  UPLOAD_FILE_ZIP,
} from 'scenes/Gallery/GalleryPage/constants';

import Container from '../components/Container';
import Image from '../components/Image';
import Preview from '../components/Preview';
import Video from '../components/Video';
import useSizes from '../hooks/useSizes';

const PreviewNewFile = ({
  progress,
  type,
  fileOverSize,
  src,
  width: originalWidth,
  height: originalHeight,
  maxWidth: originalMaxWidth,
  maxHeight: originalMaxHeight,
  attributes,
  variant,
}) => {
  const { width, height, maxWidth, maxHeight } = useSizes({
    originalWidth,
    originalHeight,
    originalMaxWidth,
    originalMaxHeight,
  });

  switch (type) {
    case UPLOAD_FILE_IMAGE: {
      return (
        <Container
          attributes={attributes}
          progress={progress}
          variant={variant}
        >
          <Image
            src={src}
            width={width}
            height={height}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
          />
        </Container>
      );
    }

    case UPLOAD_FILE_VIDEO: {
      return (
        <Container
          attributes={attributes}
          progress={progress}
          variant={variant}
        >
          {fileOverSize ? (
            <Preview icon={<VideocamIcon color={'action'} />} />
          ) : (
            <Video
              src={src}
              width={width}
              height={height}
              maxWidth={maxWidth}
              maxHeight={maxHeight}
            />
          )}
        </Container>
      );
    }

    case UPLOAD_FILE_ZIP: {
      return (
        <Container
          attributes={attributes}
          progress={progress}
          variant={variant}
        >
          <Preview icon={<InventoryIcon color={'action'} />} />
        </Container>
      );
    }

    default: {
      return null;
    }
  }
};

export default PreviewNewFile;
